import { EnvironmentProviders, inject, Injector, Provider, ProviderToken, TypeProvider } from "@angular/core";

export function transient<T>(token: ProviderToken<T>): T {
    return Injector.create({
        providers: [token as TypeProvider],
        parent: inject(Injector)
    }).get(token);
}

export function toTransient(providers: (Provider | EnvironmentProviders)[]): (Provider | EnvironmentProviders)[] {
    return providers.map(p => ({
        provide: p,
        useFactory: () => transient(p as ProviderToken<any>)
    }));
}